<template>
  <div>
    <!-- <detailsInternalRequest
      ref="details"
      v-bind="bindDetail"
    ></detailsInternalRequest> -->
    <el-row type="flex" justify="end">
      <el-col :span="4">
        <div class="box mr-5">
          <el-select
            v-model="select"
            clearable
            placeholder="Todos"
            size="mini"
            @change="Filtropordepartamento"
            class="selector"
            default-first-option
          >
            <el-option key="1" label="Vendedores" value="32"></el-option>
            <el-option
              key="2"
              label="Servicios al Cliente"
              value="47"
            ></el-option>
          </el-select>
        </div>
      </el-col>
      <el-col :span="4">
        <el-select
          v-model="year"
          placeholder="Año"
          size="mini"
          @change="fetchReport"
        >
          <el-option
            v-for="item in years"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-col>
    </el-row>
    <el-row>
      <el-col>
        <rabbey-table-3
          :border="true"
          :stripe="true"
          :loading="loading"
          :data="report"
          :columns="mapColumns"
          :summary-method="getSummaries"
          show-summary
        />
      </el-col>
    </el-row>
    <rabbey-base-drawer
      :title="title"
      :drawer.sync="drawer"
      size="85%"
      :before-close="CloseDetails"
    >
      <el-row>
        <div>
          <DetailChart ref="detailChart" :DetailParams="DetailParams" />
        </div>
        <el-col>
          <rabbey-table-3
            :border="true"
            :stripe="true"
            :loading="loadingDetail"
            :data="requests"
            :columns="columnsDetails"
          />
        </el-col>
      </el-row>
    </rabbey-base-drawer>
  </div>
</template>

<script>
import ImagePersonVue from "@/components/functionals/ImagePerson.vue";
import HyperLinkProspecting from "@/components/functionals/HyperLinkProspecting.vue";
import { MONTHS_LIST } from "@/const";
import DetailChart from "@/views/Charts/ClosingReportChart.vue";
import { formatArrayToElSelect } from "@/utils";
import DatetimeFormatter from "@/components/functionals/DatetimeFormatter.vue";
import ColorDealClasification from "@/components/functionals/ColorDealClasification.vue";
import PhaseSalesColorVue from "@/components/functionals/PhaseSalesColor.vue";
//import DatetimeFormatter from "@/components/functionals/DatetimeFormatter.vue";
export default {
  name: "DealsClosesKpi",
  components: {
    DetailChart
  },
  created() {
    this.fetchReport();
  },
  data() {
    return {
      loading: false,
      loadingDetail: false,
      selectedEmployee: this.currentUserId,
      selectedDirection: 0,
      select: "",
      bindDetail: {
        comments: [],
        descripcionLaga: "",
        descripcionCorta: ""
      },
      columns: [
        {
          prop: "VendorName",
          label: "Vendedor",
          formatter: ImagePersonVue,
          attrs: {
            imgKey: "VendorImageUrl"
          },
          minWidth: 220,
          sortable: true,
          fix: true
        }
      ],
      columnsDetails: [
        {
          prop: "DealsId",
          label: "NO",
          width: 70,
          align: "center",
          fixed: true,
          sortable: true
        },
        {
          prop: "DealDescription",
          label: "Negociación",
          minWidth: 300
        },
        {
          label: "Contacto",
          prop: "ContactName",
          minWidth: 200
        },
        {
          prop: "ProductName",
          label: "Producto",
          minWidth: 100
        },
        {
          prop: "UnitPrice",
          label: "P. Unitario",
          width: 110
        },
        {
          prop: "Quantity",
          label: "Cantidad",
          width: 110,
          sortable: true
        },
        {
          prop: "TotalAmount",
          label: "Monto total",
          align: "center",
          width: 130,
          sortable: true,
          formatter: ColorDealClasification
        },
        {
          prop: "Clasificacion",
          label: "Clasificacion",
          align: "center",
          width: 130,
          sortable: true,
          formatter: ColorDealClasification
        },
        // {
        //   prop: "Currency.Name",
        //   label: "Moneda",
        //   width: 100
        // },
        {
          prop: "phaseDescription",
          label: "fase",
          align: "center",
          width: 130,
          sortable: true,
          formatter: PhaseSalesColorVue
        },

        {
          prop: "InitialDate",
          label: "Fecha de creacion",
          formatter: DatetimeFormatter,
          width: 180
        },
        // {
        //   prop: "DaysLate",
        //   label: "Dias abierta",
        //   //formatter: DatetimeFormatter,
        //   width: 180
        // },
        {
          prop: "FinalDate",
          label: "Fecha de cierre",
          formatter: DatetimeFormatter,
          width: 180
        },
        // {
        //   prop: "SalesPersonName",
        //   label: "Vendedor",
        //   formatter: ImagePerson,
        //   minWidth: 200,
        //   attrs: {
        //     imgKey: "SalesPersonPhoto"
        //   }
        // },
        // {
        //   prop: "CreatedPersonName",
        //   label: "Creador",
        //   formatter: ImagePerson,
        //   minWidth: 250,
        //   attrs: {
        //     imgKey: "CreatedPersonPhoto"
        //   }
        // },
        // {
        //   label: "Sop. Ventas",
        //   prop: "SupportSellerName",
        //   minWidth: 250,
        //   formatter: ImagePerson,
        //   attrs: {
        //     imgKey: "SupportSellerPhoto"
        //   }
        // },
        {
          label: "Razon de cierre",
          prop: "Reason",
          minWidth: 200,
          formatter: (row) => row.Reason && row.Reason.substring(0, 50) + "..."
        }
      ],
      report: [],
      year: new Date().getFullYear(),
      request_type: null,
      title: "",
      drawer: false,
      selectedTechnician: "",
      requests: [],
      technicians: [],
      techniciansLoading: false,
      //requestColumns: requestColumns,
      createdOrClosed: true,
      serviceRequestType: null,
      DetailParams: {
        Month: 0,
        Year: 0,
        vendorId: 0,
        chartData: []
      }
    };
  },
  computed: {
    years() {
      const lowLevel = 2020;
      const currentYear = new Date().getFullYear();
      let Years = [];
      for (let i = lowLevel; i <= currentYear; i++) {
        Years.push({ label: i, value: i });
      }
      return Years;
    },
    mapColumns() {
      let columns = this.columns;
      for (let i = 0; i < 12; i++) {
        const month = MONTHS_LIST[i];
        columns.push({
          prop: month,
          label: this.$t(`months.${month}`),
          name: this.$t(`months.${month}`),
          attrs: {
            openSelect: this.openSelect,
            getType: this.getType,
            month: i + 1
          },
          formatter: HyperLinkProspecting
        });
      }

      columns.push({
        prop: "Totals",
        label: "Total",
        name: "Total",
        attrs: {
          isTotal: true,
          openSelect: this.openSelect,
          month: 0
        },
        formatter: HyperLinkProspecting
      });
      return columns;
    }
  },
  methods: {
    formatArrayToElSelect,
    fetchReport() {
      this.loading = true;

      this.$http
        .get("/api/deals/ClosingReport", {
          params: {
            year: this.year,
            Deparment: this.select
          }
        })
        .then(({ data }) => {
          this.report = data;
        })
        .catch((error) => console.error(error))
        .finally(() => (this.loading = false));
    },
    // updateSelectedEmployee(val) {
    //   this.selectedEmployee = val;
    //   this.fetchReport();
    // },
    // updateSelectedDirection(val) {
    //   this.selectedDirection = val;
    //   this.fetchReport();
    // },
    // handlePushAction(option) {
    //   if (option.command == "details") {
    //     this.bindDetail = {
    //       comments: [],
    //       descripcionLaga: option.row.Descripcion,
    //       descripcionCorta: option.row.corta
    //     };

    //     // if (option.row != null && option.row.Activities != null) {
    //     //   const c = option.row.Activities.filter(a => (a.Type = 1));
    //     //   this.bindDetail.comments = JSON.parse(JSON.stringify(c));
    //     // }
    //     this.$refs.details.drawer = true;
    //   }
    // },
    async Filtropordepartamento(selectvalue) {
      if (selectvalue) {
        this.fetchReport();
      } else {
        this.fetchReport();
      }
      // this.report.filter(x=>x.DeparmentId==)
    },
    openSelect(props) {
      this.loadingDetail = true;
      this.title = `Oportunidades cerradas por ${props.row.VendorName}`;
      this.drawer = true;
      this.DetailParams = {
        Month: props.month,
        Year: this.year,
        vendorId: props.row.userId
      };
      this.$http
        .get("/api/deals/ClosesReportDetails", {
          timeout: 3000 * 6 * 1000,
          params: {
            year: this.year,
            vendorId: props.row.userId,
            month: props.month
          }
        })
        .then(({ data }) => {
          this.requests = data;
          // this.DetailData.chartData = data.serviceChart;

          this.$refs.detailChart.getChartData();
        })
        .finally(() => (this.loadingDetail = false));
    },
    CloseDetails() {
      this.drawer = false;
      this.$refs.detailChart.bar.series[0].data = [];
      this.$refs.detailChart.loading = true;
    },
    getSummaries(param) {
      const { columns, data } = param;
      var sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "";
          return;
        }
        const values = data.map((item) => Number(item[column.property]));
        if (!values.every((value) => isNaN(value))) {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0);
        } else {
          sums[index] = "Totales :";
        }
      });
      sums = sums.map((a) => Number(a).toFixed(2));
      return sums;
    }
  }
};
</script>
